import { useCheckSessionStatus } from '../../hook/useQueryData';
import { useAuth } from '../../context/AuthContext';

const SessionWatcher = () => {
  const { isAuthenticated } = useAuth();
  const { data: status } = useCheckSessionStatus(isAuthenticated);
  console.log('Session status:', !!status);
  return null;
};

export default SessionWatcher;
